import { render, staticRenderFns } from "./expenseDetails.vue?vue&type=template&id=2d76a7b0&"
import script from "./expenseDetails.vue?vue&type=script&lang=js&"
export * from "./expenseDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports